import { render, staticRenderFns } from "./PlaceAnOrder.vue?vue&type=template&id=221810da&scoped=true"
import script from "./PlaceAnOrder.vue?vue&type=script&lang=js"
export * from "./PlaceAnOrder.vue?vue&type=script&lang=js"
import style0 from "./PlaceAnOrder.vue?vue&type=style&index=0&id=221810da&prod&style=true&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221810da",
  null
  
)

export default component.exports